import { lazy } from 'react';
import { z } from 'zod';
import { defineWidget, type WidgetDataState } from '../_sdk/types';

/**
 * Free-text note (PRD VS-042): Markdown written by the user, rendered without
 * raw HTML. No source, no fetch — the data is the props.
 */

export const MAX_BYTES = 8192;

export const byteLength = (text: string): number => new TextEncoder().encode(text).length;

export const PropsSchema = z.object({
  /** The frame's title (the brief's `title?`): every widget names it `label`. */
  label: z.string().max(80).optional(),
  content: z
    .string()
    .default('')
    .refine((s) => byteLength(s) <= MAX_BYTES),
});

export type MarkdownProps = z.output<typeof PropsSchema>;

export default defineWidget<MarkdownProps, string>({
  type: 'markdown',
  category: 'composite',
  defaultSize: { w: 3, h: 3 },
  minSize: { w: 2, h: 2 },
  propsSchema: PropsSchema,
  defaults: { content: '' },
  sourceIds: () => [],
  useData: (p): WidgetDataState<string> =>
    p.content.trim() ? { status: 'ready', data: p.content } : { status: 'empty', data: p.content },
  Render: lazy(() => import('./render')),
  Editor: lazy(() => import('./editor')),
});
